export const valeExistsOrIsZero = (value: any) => {
  return value || `${value}` === '0';
};
